/* Keos product page: size logic, gallery, add to bag, sticky bar, feeding calculator
   (KEOS_PDP_AND_COLLECTION.md · P03, P05, P07, P08). */
(function () {
  'use strict';
  var root = document.querySelector('[data-kx-pdp]');
  if (!root) return;
  var data;
  try { data = JSON.parse(root.querySelector('[data-kx-pdp-data]').textContent); } catch (e) { return; }

  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function byId(id) { for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === String(id)) return data.variants[i]; return null; }
  function track(n, d, std) { if (window.KeosTrack) window.KeosTrack(n, d, std); }

  var form = $('[data-kx-pdp-form]');
  var input = $('[data-kx-variant-input]');
  var qty = $('[data-kx-qty-input]');
  var addBtn = $('[data-kx-pdp-add]');
  var addText = $('[data-kx-add-text]');
  var err = $('[data-kx-pdp-err]');
  var current = byId(input ? input.value : data.defaultId) || data.variants[0];

  /* ---------- Gallery ---------- */
  var track_ = $('[data-kx-gal-track]');
  var slides = $$('[data-kx-gal-slide]');
  var thumbs = $$('[data-kx-gal-thumb]');
  var dots = $$('.kx-gal__dots span');
  var prev = $('[data-kx-gal-prev]');
  var next = $('[data-kx-gal-next]');
  var idx = 0;
  function show(i, smooth) {
    if (!track_ || !slides.length) return;
    idx = Math.max(0, Math.min(slides.length - 1, i));
    track_.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    sync();
  }
  function sync() {
    thumbs.forEach(function (t, i) { if (i === idx) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === slides.length - 1;
  }
  if (track_) {
    var st;
    track_.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = track_.clientWidth || 1;
        var i = Math.round(track_.scrollLeft / w);
        if (i !== idx) { idx = i; sync(); }
      }, 60);
    }, { passive: true });
    sync();
  }
  if (prev) prev.addEventListener('click', function () { show(idx - 1); });
  if (next) next.addEventListener('click', function () { show(idx + 1); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.getAttribute('data-kx-gal-thumb'))); }); });

  // Zoom (click / tap)
  var zoom = $('[data-kx-zoom]');
  var zoomTrigger = null;
  slides.forEach(function (s) {
    s.addEventListener('click', function () {
      if (!zoom) return;
      zoomTrigger = s;
      var img = $('[data-kx-zoom-img]', zoom);
      img.src = s.getAttribute('data-full');
      var inner = s.querySelector('img');
      img.alt = inner ? inner.alt : '';
      zoom.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      $('[data-kx-zoom-close]', zoom).focus();
    });
  });
  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.hidden = true;
    document.documentElement.style.overflow = '';
    if (zoomTrigger) zoomTrigger.focus();
  }
  if (zoom) {
    zoom.addEventListener('click', function (e) { if (e.target === zoom || e.target.closest('[data-kx-zoom-close]')) closeZoom(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
  }

  /* ---------- Size selection (P05): one render updates everything ---------- */
  function freeLine() {
    var el = $('[data-kx-free]');
    if (!el) return;
    var threshold = Number(el.getAttribute('data-threshold'));
    var subtotal = Number(el.getAttribute('data-subtotal')) || 0;
    var q = Math.max(1, Number(qty && qty.value) || 1);
    var remaining = threshold - (subtotal + current.price * q);
    var bar = $('[data-kx-free-bar]');
    if (remaining <= 0) { el.textContent = 'Free delivery on this order'; if (bar) bar.style.width = '100%'; }
    else {
      el.textContent = 'Add ₹' + Math.ceil(remaining / 100).toLocaleString('en-IN') + ' more for free delivery';
      if (bar) bar.style.width = Math.min(100, Math.round((threshold - remaining) / threshold * 100)) + '%';
    }
  }
  function render(opts) {
    opts = opts || {};
    if (input) input.value = current.id;
    var price = $('[data-kx-pdp-price]');
    if (price) price.textContent = current.priceF;
    var unit = $('[data-kx-unit]');
    if (unit) unit.textContent = current.unitF ? ' · ' + current.unitF : '';
    if (addBtn) {
      addBtn.disabled = !current.available;
      addBtn.classList.toggle('is-oos', !current.available);
      addText.textContent = current.available ? 'Add to bag · ' + current.priceF : 'Out of stock';
    }
    var now = $('.kx-buy__now');
    if (now) now.hidden = !current.available;
    var qbox = $('.kx-qtybox');
    if (qbox) qbox.hidden = !current.available;
    var sa = document.querySelector('[data-kx-stick-add]');
    if (sa) { sa.disabled = !current.available; sa.textContent = current.available ? 'Add to bag' : 'Out of stock'; }
    var sp = document.querySelector('[data-kx-stick-price]');
    if (sp) sp.textContent = current.priceF;
    var sm = document.querySelector('[data-kx-stick-meta]');
    if (sm) sm.textContent = current.title + (current.unitF ? ' · ' + current.unitF : '');
    if (qty && current.max !== null && current.max > 0) qty.max = current.max;
    freeLine();
    if (current.mediaId) {
      var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(current.mediaId); });
      if (i > -1) show(i);
    }
    if (!opts.silentUrl) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      window.history.replaceState({}, '', url.toString());
    }
    document.dispatchEvent(new CustomEvent('kx:variant', { detail: current }));
  }
  $$('[data-kx-size]').forEach(function (r) {
    r.addEventListener('change', function () {
      var v = byId(r.value);
      if (!v) return;
      current = v;
      render();
      track('SizeSelected', { size: v.title, price: v.price / 100 });
    });
  });
  window.KeosPdp = {
    select: function (id) {
      var r = root.querySelector('[data-kx-size][value="' + id + '"]');
      if (r && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    },
    current: function () { return current; },
    variants: data.variants
  };

  // Quantity stepper
  $$('[data-kx-q]').forEach(function (b) {
    b.addEventListener('click', function () {
      var max = Number(qty.max) || 99;
      qty.value = Math.max(1, Math.min(max, (Number(qty.value) || 1) + Number(b.getAttribute('data-kx-q'))));
      freeLine();
    });
  });
  if (qty) qty.addEventListener('input', freeLine);

  /* ---------- Add to bag (A01 states) ---------- */
  function add(fromSticky) {
    if (!current.available || addBtn.getAttribute('aria-busy') === 'true') return;
    var q = Math.max(1, Number(qty.value) || 1);
    err.hidden = true;
    addBtn.disabled = true;
    addBtn.setAttribute('aria-busy', 'true');
    addText.textContent = 'Adding';
    var go = window.KeosBag ? window.KeosBag.add(current.id, q) : Promise.reject(new Error('No connection. Try again.'));
    go.then(function () {
      addBtn.removeAttribute('aria-busy');
      addBtn.classList.add('is-added');
      addText.textContent = 'Added to your bag';
      track('AddToCart', { content_ids: [String(current.id)], content_type: 'product', value: (current.price * q) / 100, currency: 'INR' }, true);
      setTimeout(function () {
        addBtn.classList.remove('is-added');
        addBtn.disabled = false;
        addText.textContent = 'Add to bag · ' + current.priceF;
        if (window.KeosBag) window.KeosBag.open(fromSticky ? document.querySelector('[data-kx-stick-add]') : addBtn);
      }, 600);
    }).catch(function (e) {
      addBtn.removeAttribute('aria-busy');
      addBtn.disabled = false;
      addText.textContent = 'Try again';
      err.textContent = /sold out|already|quantity|stock/i.test(e.message) ? 'That size just sold out.' : (e.message || 'No connection. Try again.');
      err.hidden = false;
    });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(false); });

  /* ---------- Buy it now: add to the existing bag, then check out the whole bag ----------
     Shopify's button (and Razorpay Magic's own handling of it) would check out this item alone and,
     with Magic, empty the shopper's bag first. Window capture runs before both. */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kx-buy__now .shopify-payment-button__button');
    if (!b || !root.contains(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!current.available || b.getAttribute('aria-busy') === 'true') return;
    var q = Math.max(1, Number(qty.value) || 1);
    var label = b.textContent;
    err.hidden = true;
    b.setAttribute('aria-busy', 'true');
    b.textContent = 'Opening checkout…';
    var go = window.KeosBag ? window.KeosBag.add(current.id, q) : Promise.reject(new Error('No connection. Try again.'));
    go.then(function (cart) {
      track('AddToCart', { content_ids: [String(current.id)], content_type: 'product', value: (current.price * q) / 100, currency: 'INR' }, true);
      track('InitiateCheckout', { value: cart ? cart.total_price / 100 : (current.price * q) / 100, currency: 'INR', num_items: cart ? cart.item_count : q }, true);
      if (window.KeosCheckout) window.KeosCheckout(); else window.location.href = '/checkout';
    }).catch(function (x) {
      err.textContent = /sold out|already|quantity|stock/i.test(x.message) ? 'That size just sold out.' : (x.message || 'No connection. Try again.');
      err.hidden = false;
    }).then(function () {
      setTimeout(function () { b.removeAttribute('aria-busy'); b.textContent = label; }, 1500);
    });
  }, true);
  var stickAdd = document.querySelector('[data-kx-stick-add]');
  if (stickAdd) stickAdd.addEventListener('click', function () { add(true); });

  // Mobile sticky bar: appears once the main Add button scrolls out of view
  var stick = document.querySelector('[data-kx-stick]');
  if (stick && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      stick.classList.toggle('is-on', off);
      stick.setAttribute('aria-hidden', off ? 'false' : 'true');
      if (stickAdd) stickAdd.tabIndex = off ? 0 : -1;
    }).observe(addBtn);
  }

  // Smooth scroll to the calculator
  $$('[data-kx-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var f = t.querySelector('input, button');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 500);
    });
  });

  // Welcome-offer line: once the code is applied (kx.js handles the click), say so
  var offerBtn = $('[data-kx-offer-apply]');
  if (offerBtn) {
    offerBtn.addEventListener('click', function () {
      setTimeout(function () { offerBtn.textContent = 'Applied — see it in your bag'; offerBtn.disabled = true; }, 900);
    });
  }

  // PDP load event with the catalogue variant id (T01)
  track('ViewContent', { content_ids: [String(current.id)], content_type: 'product', value: current.price / 100, currency: 'INR' }, true);

  render({ silentUrl: true });

  /* ---------- Feeding calculator (P07) ---------- */
  var calc = document.querySelector('[data-kx-calc]');
  if (calc) {
    var table;
    try { table = JSON.parse(calc.querySelector('[data-kx-calc-table]').textContent); } catch (e) { table = null; }
    if (table && table.rows && table.rows.length) {
      var slider = calc.querySelector('[data-kx-calc-weight]');
      var wOut = calc.querySelector('[data-kx-calc-w]');
      var gOut = calc.querySelector('[data-kx-calc-g]');
      var tiles = calc.querySelector('[data-kx-calc-tiles]');
      var choose = calc.querySelector('[data-kx-calc-choose]');
      var chips = Array.prototype.slice.call(calc.querySelectorAll('[data-kx-calc-act]'));
      var pressed = calc.querySelector('[data-kx-calc-act][aria-pressed="true"]');
      var act = pressed ? Number(pressed.getAttribute('data-kx-calc-act')) : 0;
      var used = false;
      function grams(w) {
        var rows = table.rows;
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i];
          if (w <= r.max || i === rows.length - 1) {
            var span = r.g[act] || r.g[0];
            var lo = r.min, hi = r.max;
            var tt = hi > lo ? Math.min(1, Math.max(0, (w - lo) / (hi - lo))) : 0;
            return Math.round((span[0] + (span[1] - span[0]) * tt) / 5) * 5;
          }
        }
        return 0;
      }
      function update() {
        var w = Number(slider.value);
        wOut.textContent = (w % 1 ? w.toFixed(1) : w) + ' kg';
        slider.setAttribute('aria-valuetext', w + ' kilograms');
        var g = grams(w);
        gOut.textContent = g + ' g';
        var sizes = data.variants.filter(function (v) { return v.grams > 0 && v.available; }).sort(function (a, b) { return a.grams - b.grams; });
        var pick = null;
        sizes.forEach(function (v) { if (!pick && Math.floor(v.grams / g) >= 28) pick = v; });
        if (!pick && sizes.length) pick = sizes[sizes.length - 1];
        tiles.innerHTML = sizes.map(function (v) {
          var days = g > 0 ? Math.floor(v.grams / g) : 0;
          var on = pick && v.id === pick.id;
          return '<div class="kx-calc__tile' + (on ? ' is-pick' : '') + '"><span class="kx-calc__size">' + v.title + '</span>' +
            '<strong>' + days + ' day' + (days === 1 ? '' : 's') + '</strong>' +
            '<span class="kx-calc__unit">' + (v.unitF || '') + (on ? ' · best for this weight' : '') + '</span></div>';
        }).join('');
        if (pick) {
          choose.hidden = false;
          choose.textContent = 'Choose ' + pick.title + ' · ' + pick.priceF;
          choose.setAttribute('data-id', pick.id);
        } else choose.hidden = true;
      }
      slider.addEventListener('input', function () {
        update();
        if (!used) { used = true; track('FeedingCalculatorUsed', { weight_band: Math.round(Number(slider.value) / 5) * 5 + ' kg' }); }
      });
      chips.forEach(function (c, i) {
        c.addEventListener('click', function () {
          act = Number(c.getAttribute('data-kx-calc-act'));
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          update();
        });
      });
      choose.addEventListener('click', function () {
        window.KeosPdp.select(choose.getAttribute('data-id'));
        var top = document.querySelector('.kx-buy');
        if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () { if (addBtn) addBtn.focus({ preventScroll: true }); }, 600);
      });
      update();
    }
  }
})();
